export var CoolDownDefault = 15; // sec;
export var WIDGET_HEIGHT = 602; //px
export var HEADER_HEIGHT = 96; // px
export var EMPTY_FOOTER_HEIGHT = 44; //px
